import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconPhone = ({ t, className, height, width, fill }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox='0 0 19 20'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{t('Phone')}</title>
    <path
      fill={fill}
      fillRule='evenodd'
      stroke='#000'
      strokeWidth='0.5'
      d='M9.692 17.714c-4.253 0-7.714-3.46-7.714-7.714 0-4.254 3.46-7.714 7.714-7.714 4.254 0 7.715 3.46 7.715 7.714 0 4.254-3.46 7.714-7.715 7.714zM9.692 1c-4.962 0-9 4.037-9 9s4.038 9 9 9c4.963 0 9-4.037 9-9s-4.037-9-9-9z'
      clipRule='evenodd'
    />
    <path
      fill={fill}
      d='M11.247 16.5c-1.402.547-2.576-.285-2.903-.612-.097-.097-1.67-1.52-1.883-5.616-.171-3.296 1.297-5.188 1.598-5.526.293-.33 1.167-1.016 2.876-.466.212.068.521.314.525.454.001.062-.533 2.492-.557 2.566a.45.45 0 01-.107.182c-.068.068-.204.102-.407.102-.203 0-.406-.018-.61-.052a4.509 4.509 0 00-.6-.063c-.197-.007-.326.02-.387.082-.151.165-.58.867-.41 2.773.172 1.906.428 2.65.459 2.716a.533.533 0 00.095.145c.064.064.194.098.39.101.197.004.969-.098 1.172-.088.203.011.34.052.412.123.05.05.089.113.117.188.028.075.721 2.506.722 2.564.002.16-.301.35-.502.428z'
    />
  </svg>
)

export default Icon(IconPhone)
